function startCountdown() {
  let countdownTime = 2.45 * 60 * 60 * 1000; // hours to milliseconds
  // Format time
  function formatTime(ms) {
    const hours = Math.floor(ms / (1000 * 60 * 60));
    const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((ms % (1000 * 60)) / 1000);
    return { hours, minutes, seconds };
  }

  // Update the countdown every second
  const interval = setInterval(() => {
    if (countdownTime <= 0) {
      clearInterval(interval);
      console.log("Countdown complete!");
      return;
    }
    // Decrement
    countdownTime -= 1000;
    // Formatted time
    const { hours, minutes, seconds } = formatTime(countdownTime);
    document.querySelector(
      ".sale-countdown"
    ).innerHTML = `${hours}h ${minutes}m ${seconds}s`;
  }, 1000);
}

// Start the countdown
window.onload = () => {
  startCountdown();
};
